import { EN } from "../ui/constants";
import Cookies from "js-cookie";

const jsonRequest = (
  path,
  method = "GET",
  body = null,
  options = { headers: {} },
  session = Cookies.get()
) => {
  options.headers = {
    ...options.headers,
    Authentication: session.session,
    "Content-Type": "application/json",
  };
  return fetch(`${EN.BASE_URL}/${path}`, {
    method,
    body: !!body ? JSON.stringify(body) : undefined,
    ...options,
  }).then((res) => {
    return res.json().then((json) => {
      if (!res.ok && json.message) {
        throw new Error(json.message);
      } else if (!res.ok) {
        throw new Error("Server error: " + res.status);
      } else return json;
    });
  });
};

export const getUserProfile = () => {
  return jsonRequest(`get_profile`);
};

export const updateUserProfile = (
  phone,
  country,
  address,
  nick_name,
  first_name,
  last_name,
  date_of_birthday,
  avatar,
  receive_newsletter,
  receive_updates,
  email,
  post_code,
  suburb,
  state,
  license,
  id = null,
  teamId
) => {
  return jsonRequest(
    teamId ? `update_profile?teamId=${teamId}` : "update_profile",
    "POST",
    {
      phone,
      country,
      address,
      nick_name,
      first_name,
      last_name,
      date_of_birthday,
      avatar,
      receive_newsletter,
      receive_updates,
      email,
      post_code,
      suburb,
      state,
      license,
      id,
    }
  );
};

export const getEventsList = () => {
  return jsonRequest(`user_events_lists`);
};
export const getTeamsList = (isGroupBy) => {
  const grouBy = isGroupBy ? true : false;
  return jsonRequest(`all_user_teams?isGroupBy=${grouBy}`);
};

export const createTeam = (car_info, team_info) => {
  return jsonRequest(`create_team`, "POST", { car_info, team_info });
};

export const getComingEvents = () => {
  return jsonRequest(`comingEvents`);
};
export const getBusyCarNumber = (id) => {
  return jsonRequest(`cars_numbers_in_event?id=${id}`);
};
export const getCarValues = () => {
  return jsonRequest(`car_values`);
};
export const getRacingBracket = () => {
  return jsonRequest(`racing_bracket`);
};

export const getTeamById = (id) => {
  return jsonRequest(`team_profile?id=${id}`);
};

export const updateTeam = (id, car_info, team_info) => {
  return jsonRequest(`update_team_profile`, "POST", {
    id,
    car_info,
    team_info,
  });
};
export const sendInvitation = (id, email) => {
  return jsonRequest(`invite_to_team`, "POST", { team_id: id, email });
};
export const getEventById = (id) => {
  return jsonRequest(`event?id=${id}`);
};
export const getTeamsByEventId = (id) => {
  return jsonRequest(`teams_by_event_id?id=${id}`);
};

export const joinEvent = (id, role, isCopy) => {
  return jsonRequest(`join_event`, "POST", { team_id: id, role, isCopy });
};

export const deleteUserFromMember = (id) => {
  return jsonRequest(`reject_user_from_member?member_id=${id}`);
};

export const approveUserToSlot = (id, slot) => {
  return jsonRequest(`approve_user_to_slot`, "POST", {
    pending_member_id: id,
    slot_type: slot,
  });
};

export const deleteUserFromSlot = (id) => {
  return jsonRequest(`reject_user_from_slot?slot_id=${id}`);
};

export const payForSlot = (id, nonce) => {
  return jsonRequest(`pay_for_team_slot`, "POST", { slot_id: id, nonce });
};

export const payForSlots = (team_id, driver_count, crew_count, nonce) => {
  return jsonRequest(`pay_for_team_slots`, "POST", {
    team_id,
    driver_count: driver_count || 0,
    crew_count: crew_count || 0,
    nonce,
  });
};

export const addLicenseForSlot = (id, license, exp_license_time) => {
  return jsonRequest(`add_license_to_slot`, "POST", {
    id,
    license,
    exp_license_time,
  });
};
export const assignPayment = (from_slot_id, to_slot_id) => {
  return jsonRequest(`assign_payment_to_another_slot`, "POST", {
    from_slot_id,
    to_slot_id,
  });
};

export const deleteFromTeam = (id) => {
  return jsonRequest(`leave_team?team_id=${id}`, "DELETE");
};
export const getInvoice = (id) => {
  return jsonRequest(`invoice?slot_id=${id}`);
};

export const reCreateTeam = (team_id, event_id, isCopy) => {
  return jsonRequest(`re_create_team`, "POST", { team_id, event_id, isCopy });
};

export const checkParticipation = (event_id) => {
  return jsonRequest(`check_participation_in_event?event_id=${event_id}`);
};
